var Control                    = require("enyo/Control"),
    CoverPlaceholder           = require("app/ui/covers/CoverPlaceholder"),
    GridArrangerOptions        = require("app/ui/repeaters/GridArrangerOptions"),
    HyperLinkSupport           = require("enyo-ui/HyperLinkSupport"),
    IconButton                 = require("app/ui/IconButton"),
    Repeater                   = require("enyo-ui/Repeater"),
    RepeaterArrayDataAdapter   = require("enyo-ui/RepeaterArrayDataAdapter"),
    RepeaterDrawLoopSupport    = require("enyo-ui/RepeaterDrawLoopSupport"),
    RepeaterPaddedGridArranger = require("enyo-ui/RepeaterPaddedGridArranger"),
    ThumbnailPlaceholder       = require("app/ui/thumbnails/ThumbnailPlaceholder"),
    frameThrottle              = require("enyo-perf/utils").frameThrottle,
    icons                      = require("app/theme/icons"),
    kind                       = require("enyo/kind"),
    onHyperlinkTap             = require("app/utils/onHyperlinkTap"),
    resolveCoverKind           = require("app/utils/resolveCoverKind"),
    resolveThumbnailKind       = require("app/utils/resolveThumbnailKind");

require("app/ui/repeaters/GridRow.less");
require("app/theme/IconButton--media-row.less");

module.exports = kind(/** @lends  app.ui.repeaters.GridRow.prototype */ {

    /**
     * @private
     */
    name: "app.ui.repeaters.GridRow",

    /**
     * @private
     */
    classes: "app-ui-repeaters-grid-row",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * Whether to display a button to another page with more content.
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    showMoreButton: true,

    /**
     * @private
     */
    components: [{
        name:       "header",
        classes:    "app-ui-repeaters-grid-row__header",
        components: [{
            name:    "title",
            tag:     "h2",
            classes: "app-ui-repeaters-grid-row__title"
        }, {
            name:          "moreButton",
            kind:          IconButton,
            classes:       "app-ui-repeaters-grid-row__more-button",
            icon:          icons["app.ui.repeaters.GridRow.moreButton"],
            iconAlignment: "right",
            theme:         "media-row",
            mixins:        [HyperLinkSupport],
            ontap:         "onHyperlinkTap"
        }]
    }, {
        name:            "grid",
        kind:            Repeater,
        classes:         "app-ui-repeaters-grid-row__grid",
        mixins:          [RepeaterDrawLoopSupport],
        childFormFactor: "portrait",
        childSize:       "md",
        showTitles:      true,
        dataAdapterKind: RepeaterArrayDataAdapter,
        arrangerKind:    RepeaterPaddedGridArranger,
        arrangerOptions: GridArrangerOptions,

        /**
         * Determine which placeholder to show.
         *
         * @return  {enyo.Control}  The placeholder kind.
         * @public
         */
        getPlaceholderKind: function() {
            switch (this.get("childFormat")) {
                case "category_grid":
                case "category":
                case "cover":
                    return CoverPlaceholder;
                case "thumbnail":
                    return ThumbnailPlaceholder;
                default:
                    return null;
            }
        },

        /**
         * Optional extra options to merge into the placeholder kind at
         * creation time.
         *
         * @type {Object=}
         * @public
         */
        placeholderOptions: {
            bindings: [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }]
        },

        /**
         * Determine which kind to use to display category items.
         *
         * @param   {Object}        media  The media item
         * @return  {enyo.Control}  The kind.
         * @public
         */
        getChildKind: function(media) {
            switch (this.get("childFormat")) {
                case "category_grid":
                case "category":
                case "cover":
                    return resolveCoverKind(media);
                case "thumbnail":
                    return resolveThumbnailKind(media);
                default:
                    return Control;
            }
        },

        /**
         * Optional extra options to merge into the child kind at creation time.
         *
         * @type {Object}
         * @public
         */
        childOptions: {
            bindings: [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.showNewRibbons",
                to:   ".showNewRibbon",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showNewRibbon Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showNewRibbon) {
                    if (showNewRibbon === undefined) {
                        return this.get("showNewRibbon");
                    }
                    else {
                        return showNewRibbon;
                    }
                }
            }, {
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }]
        },
        drawAsync: true
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".$.grid.showTitles",
        to:   ".showTitles"
    }],

    /**
     * @private
     */
    observers: {
        update: ["data", "showMoreButton"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @private
     */
    showTitlesChanged: function() {
        if (!this.$.grid.get("showTitles")) {
            while (this.hasClass("has-content-titles")) {
                this.removeClass("has-content-titles");
            }
        }
        else if (!this.hasClass("has-content-titles")) {
            this.addClass("has-content-titles");
        }
    },

    /**
     * Update the contents of the row.
     *
     * @public
     */
    update: function() {
        this.updateMoreButtonVisibility();
    },

    /**
     * Resolve the visibility of the more button.
     *
     * @protected
     */
    updateMoreButtonVisibility: function() {
        this.$.moreButton.set("showing", this.get("showMoreButton"));
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}       Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
